import styled from '@emotion/styled';

import { CustomBox } from '@shared/ui-kit-styled';

export const CustomSection = styled(CustomBox)`
  padding: 3rem;
`;
